import SideBarHeading from "./SideBarHeading";
import type { SideBarHeadingProps } from "./SideBarHeading.d";

export { SideBarHeading };
export type { SideBarHeadingProps };
